import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/screen.svg")